import Image from 'next/legacy/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from 'styled-components'

import { breakpoints } from '@/styles'
import { useCompanyProfile } from '@/lib/company'
import BaseHeader from '@/features/Header/base'

const StyledHeader = styled(BaseHeader)`
  .inner-wrapper {
    flex-direction: row-reverse;
    justify-content: space-between;
    > div:first-of-type {
      flex: 0 1 auto;
    }
  }
  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    .inner-wrapper {
      margin: 0 15px;
    }
  }
`

const LogosWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`

const LogoWrapper = styled.div`
  position: relative;
  cursor: pointer;
  height: ${props => props.customSize?.height ?? '42px'};
  width: ${props => props.customSize?.width ?? '130px'};

  @media only screen and (max-width: ${breakpoints.ipadMiniMax}) {
    height: ${props => props.customSize?.mobileHeight ?? '36px'};
    width: ${props => props.customSize?.mobileWidth ?? '100px'};
  }
`

const CompanyProfile = ({
  data = {},
  footerOnScreen,
  listingsOnScreen,
  metadata
}) => {
  const router = useRouter()
  const companyId = router.query.id
  const companyProfile = useCompanyProfile(companyId)
  const ProfileComponent = companyProfile?.profile || null

  return (
    <>
      <StyledHeader showTranslate position="static">
        {!!companyProfile?.logo && (
          <Link
            href={companyProfile.siteUrl ?? router.asPath}
            passHref
            aria-label={companyProfile?.logoAlt}
            aria-current="page"
            target={companyProfile.siteUrl ? '_blank' : '_self'}
          >
            <LogosWrapper>
              <LogoWrapper customSize={companyProfile.customSize}>
                <Image
                  src={companyProfile?.logo}
                  alt=""
                  sizes="130px"
                  layout="fill"
                  objectFit="contain"
                />
              </LogoWrapper>
              {companyProfile?.secondaryLogo && (
                <LogoWrapper customSize={companyProfile.customSize}>
                  <Image
                    src={companyProfile?.secondaryLogo}
                    alt=""
                    sizes="130px"
                    layout="fill"
                    objectFit="contain"
                  />
                </LogoWrapper>
              )}
            </LogosWrapper>
          </Link>
        )}
      </StyledHeader>
      {!!companyProfile?.profile && (
        <ProfileComponent
          data={data}
          footerOnScreen={footerOnScreen}
          listingsOnScreen={listingsOnScreen}
          metadata={metadata}
        />
      )}
    </>
  )
}

export default CompanyProfile
